<script lang="ts">
  import { Button, Progress } from "sveltestrap";
  import FeatherIcon from "svelte-feather-icon";
</script>

<ul>
  <li>
    <Button outline color="primary">
      <FeatherIcon icon="database" />{"Storage"}
    </Button>
    <div class="m-t-15">
      <div class="progress sm-progress-bar mb-1">
        <Progress bar value={25} color="primary" />
      </div>
      <p>{"25 GB of 100 GB used"}</p>
    </div>
  </li>
</ul>
